import { useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { TopBar, Stripe, Footer, SmsDisclosure } from "@/components/Chrome";
import { Hero } from "@/components/Hero";
import { Criteria } from "@/components/Criteria";
import { Sponsor } from "@/components/Sponsor";
import { ApplicationForm } from "@/components/ApplicationForm";
import { Confirmation } from "@/components/Confirmation";
import { LegalPage } from "@/components/LegalPage";
import { EFFECTIVE, PRIVACY, TERMS } from "@/content/legal";

const Home = ({ lenisRef }) => {
  const [submitted, setSubmitted] = useState(null);
  const confRef = useRef(null);

  useEffect(() => {
    if (submitted === null || !confRef.current) return;
    lenisRef.current?.scrollTo(confRef.current, { offset: -20 });
  }, [submitted, lenisRef]);

  return (
    <>
      <Hero />
      <Stripe />
      {submitted === null ? (
        <main className="page-body" data-testid="page-body">
          <Criteria />
          <Sponsor />
          <ApplicationForm onSubmitted={setSubmitted} />
        </main>
      ) : (
        <div ref={confRef}><Confirmation firstName={submitted} /></div>
      )}
    </>
  );
};

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <TopBar />
        <Routes>
          <Route path="/" element={<Home lenisRef={lenisRef} />} />
          <Route path="/privacy" element={<LegalPage testId="privacy-page" label="Iron Gate Consulting" title="Privacy Policy" effective={EFFECTIVE} sections={PRIVACY} />} />
          <Route path="/terms" element={<LegalPage testId="terms-page" label="Iron Gate Consulting" title="Terms of Service" effective={EFFECTIVE} sections={TERMS} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <SmsDisclosure />
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
